import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../../components/Layout';
import PageHeader from '../../components/PageHeader';
import ModularBlocks from '../../components/ModularBlocks';
import ContactForm from '../../components/ContactForm';
import CompanyReviews from '../../components/CompanyReviews';
import { getSchemaDescription, getServiceSchemaData } from '../../utils';

const ProjectPageTemplate = ({
  data: {
    datoCmsProject: {
      seoMetaTags,
      title,
      companyLogo,
      modularBlocks,
      serviceSchema,
    },
    datoCmsPlantsForBusiness: { sitewideNotices },
  },
}) => {
  const serviceData = getServiceSchemaData({
    serviceSchema,
    seoMetaTags,
    title,
  });

  return (
    <Layout
      title={title}
      description={getSchemaDescription(seoMetaTags)}
      service={serviceData}
      sitewideNotices={sitewideNotices}
    >
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        <PageHeader
          overline="Projects"
          heading={title}
          text=""
          logo={companyLogo}
          breadcrumbs={[
            { slug: 'plants-for-business', text: 'Plants for Business' },
          ]}
        />
        <ModularBlocks items={modularBlocks} isProjectPage={true} />
      </main>
      <ContactForm />
      <CompanyReviews />
    </Layout>
  );
};

export const ProjectPageTemplateQuery = graphql`
  query ProjectPageTemplateQuery($id: String!) {
    datoCmsProject(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      companyLogo {
        url
        alt
      }
      modularBlocks {
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...FeaturedLogosModularBlockFragment
        ...FullWidthImageModularBlockFragment
        ...HighlightedTextModularBlockFragment
        ...ImageContentModularBlockFragment
        ...ImageGalleryModularBlockFragment
        ...InternalVideoModularBlockFragment
      }
      serviceSchema {
        serviceType
        serviceAreaServed
      }
    }
    datoCmsPlantsForBusiness {
      sitewideNotices {
        text
      }
    }
  }
`;

export default ProjectPageTemplate;
